import React, {Component} from 'react';

import * as customers from 'customers/actions/customers';
import {connect} from 'react-redux';
import BootstrapTable from 'react-bootstrap-table-next';
import paginationFactory from 'react-bootstrap-table2-paginator';
import Search from 'customers/Search';
import NewCustomer from 'customers/NewCustomer';
import {customerListColumns, customerHoursColumns} from 'customers/CustomerListColumns';
import ToggleActive from 'customers/ActiveCustomerButton';
import autobind from 'autobind-decorator';
import Loading from 'apa/components/Loading';
import {Button} from 'reactstrap';

@connect(
    state => {
        return {
            customers: state.customers
        }
    },
    dispatch => {
        return {
            toggleHours: () => dispatch(customers.toggleHours())
        }
    }
)
export class ToggleHours extends Component {
    render() {
        return (
            <Button color='primary' onClick={this.props.toggleHours}>Stunden</Button>
        )
    }
}

@connect(
    state => {
        return {
            customers: state.customers,
        }
    },
    dispatch => {
        return {
            fetchCustomers: () => dispatch(customers.fetchCustomers()),
            changePage: (page, sizePerPage) => dispatch(customers.changePage(page, sizePerPage)),
            sortPage: (sortField, sortOrder) => dispatch(customers.sortPage(sortField, sortOrder))
        }
    }
)
export default class CustomerList extends Component {

    componentDidMount() {
        this.props.fetchCustomers();
    }

    @autobind
    onTableChange(type, {page, sortField, sortOrder, sizePerPage}) {
        if (type === 'pagination') {
            this.props.changePage(page, sizePerPage)
        }
        if (type === 'sort') {
            this.props.sortPage(sortField, sortOrder)
        }
    }

    render() {
        const {customerList, isLoading} = this.props.customers;
        const columns = this.props.customers.showHours ? customerHoursColumns : customerListColumns;
        if (isLoading) {
            return <Loading/>
        } else {
            const {
                totalCount,
                sizePerPage,
                currentPage
            } = this.props.customers;
            return (
                <div>
                    <div className="form-row">
                        <div className="col-sm-3">
                            <Search/>
                        </div>
                        <div className="col-sm-3">
                            <NewCustomer/>
                        </div>
                        <div className="col-sm-1 offset-sm-4">
                            <ToggleActive/>
                        </div>
                        <div className="col-sm-1">
                            <ToggleHours/>
                        </div>
                    </div>
                    <BootstrapTable
                        remote
                        keyField='id'
                        data={customerList}
                        columns={columns}
                        pagination={
                            paginationFactory(
                                {
                                    page: currentPage,
                                    sizePerPage: sizePerPage,
                                    totalSize: totalCount,
                                    sizePerPageList: [{
                                        text: '10', value: 10
                                      }, {
                                        text: '50', value: 50
                                      }, {
                                        text: '100', value: 100
                                      },
                                    ]
                                }
                            )
                        }
                        responsive
                        striped
                        onTableChange={this.onTableChange}
                        bootstrap4
                    />
                </div>
            )
        }

    }

}

